import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Button } from 'reactstrap';

import SingleThumbnail from '../../PageProductDetails/Detail/Thumbnails/SingleThumbnail';
import LeftSideCheckout from '../../PageCheckout/Detail/LeftSideCheckout';
import RightSideCheckout from '../../PageCheckout/Detail/RightSideCheckout';

const BodyCheckout = props => {
  return(
    <Row className="row-body-checkout">
        <Col className="col-body-checkout">
          <LeftSideCheckout
            {...props}
          />
        </Col>
        <Col className="col-body-checkout">
          <RightSideCheckout
          /* From old code */
          {...props}

          
            dataAuth={props.dataAuth}
            sell={props.dataSell}
            onClickAddress={props.onClickAddress}
            handleClickAddress={props.handleClickAddress}
            clearAddress={props.clearAddress}
            // dataShipping={props.dataShipping}

            _balanceUser={props._balanceUser}
            _askingPrice={props._askingPrice}
            _shouldRedirect={props._shouldRedirect}
          />

        </Col>
      </Row>
  )
}

export default BodyCheckout;